
import { defineComponent } from 'vue'
import { useStore } from '@/store/index'
import BaseSvgIcon from '@/components/BaseSvgIcon.vue'
import { mdiMenu, mdiClose, mdiMagnify, mdiArrowLeft } from '@mdi/js'
import BaseLogo from '@/components/BaseLogo.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'
import { HOME_PATH } from '@/router/routes'
import SearchBox from '@/components/SearchBox.vue'

export default defineComponent({
  components: { BaseSvgIcon, BaseLogo, LayoutsAuthWidth, SearchBox },
  setup() {
    const store = useStore()

    return {
      store,
      mdiMenu,
      mdiClose,
      mdiMagnify,
      mdiArrowLeft,
      homePath: HOME_PATH,
    }
  },
})
